




















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'story-preview',
})
export default class StoryPreview extends Vue {
  @Prop() htmlText!: string;

  @Prop({ type: Number }) count!: number;

  @Prop({ type: Number }) current!: number;

  @Prop({ type: String }) title!: string;
}
